import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { HHNTheme } from "hhn-commons";

export const LinkContentWrapper = styled(Box)`
  margin-top: 10px;
  margin-bottom: 5px;
  width: 100%;
  padding: 12px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  background-color: ${HHNTheme.surfaceVariant};
  font-weight: bold;
  color: ${HHNTheme.primary};
  align-items: center;
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 0;

  & a {
    overflow-wrap: anywhere;
    word-break: break-word;
    min-width: 0;
  }
`;
